// extracted by mini-css-extract-plugin
module.exports = {"list":"styles_list__2u-QC","list_item":"styles_list_item__2AGj5","more":"styles_more__3uqqH"};